
import { Component, Prop, Vue } from 'vue-property-decorator'
import CloseCrossCtrl from '~/components/common/ctrls/CloseCrossCtrl.vue'
import DashboardButton from '~/components/common/buttons/DashboardButton.vue'
import Icon from '~/components/common/icon/Icon.vue'
import { getTrialEndingSoonKind } from '~/lib/utils/trialEndingSoon'

const MODAL_NAME = 'LoopTrialExtensionShareModal'

@Component({
  name: 'LoopTrialExtensionShareModal',
  components: {
    CloseCrossCtrl,
    DashboardButton,
    Icon
  }
})
export default class LoopTrialExtensionShareModal extends Vue {
  @Prop({ type: String, required: true }) readonly shareUrl!: string
  @Prop({ type: String, default: null }) readonly freeTrialEndDate!: string | null

  get trialEndingSoonKind() {
    return getTrialEndingSoonKind(this.freeTrialEndDate ?? undefined)
  }

  get isUrgent() {
    return this.trialEndingSoonKind != null
  }

  closeModal = () => {
    this.$mixpanel.track(this.$mixpanel.events.TRIAL_EXTENSION_POPUP_CLOSED)
    this.$modal.hide(MODAL_NAME)
  }

  handleCopyClick = () => {
    this.$mixpanel.track(this.$mixpanel.events.TRIAL_EXTENSION_LINK_COPIED)
    window.alert('Link copied!')
  }
}
